
'use strict';

export default function(userOptions) {
	'ngInject';
    return userOptions;
}